/* Autogenerated file. Do not edit manually. */
/* tslint:disable */
/* eslint-disable */

import {
  Address,
  ExecutableScript,
  ExecuteScriptParams,
  ExecuteScriptResult,
  Script,
  SignerProvider,
  HexString,
} from "@alephium/web3";
import { getContractByCodeHash } from "./contracts";
import { default as AlphStakeAndLockScriptJson } from "../AlphStakeAndLock.ral.json";
import { default as XAlphUnlockAndStartUnstakeScriptJson } from "../XAlphUnlockAndStartUnstake.ral.json";
import * as types from "./types";

export const AlphStakeAndLock = new ExecutableScript<{
  xAlphToken: HexString;
  xAlphStakeVault: HexString;
  amount: bigint;
}>(
  Script.fromJson(AlphStakeAndLockScriptJson, "", types.AllStructs),
  getContractByCodeHash
);

export const XAlphUnlockAndStartUnstake = new ExecutableScript<{
  xAlphToken: HexString;
  xAlphStakeVault: HexString;
  amount: bigint;
}>(
  Script.fromJson(XAlphUnlockAndStartUnstakeScriptJson, "", types.AllStructs),
  getContractByCodeHash
);
